<template>
  <div class="order-totals-row" :class="`order-totals-row--${variant}`">
    <div class="order-totals-row__text">{{ label }}</div>
    <transition name="toggle-fade">
      <div v-show="isValueVisible" class="order-totals-row__amount">{{ value }}</div>
    </transition>
  </div>
</template>

<script>
export const VARIANTS = {
  default: 'default',
  bold: 'bold',
}

export default {
  name: 'OrderTotalsRow',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: { type: [String, Number], required: true },
    variant: {
      type: String,
      default: VARIANTS.default,
      validator(value) {
        return Object.values(VARIANTS).includes(value)
      },
    },
    isValueVisible: { type: Boolean, default: true },
  },
}
</script>
<style scoped lang="scss">
.order-totals-row {
  display: flex;
  justify-content: space-between;
  color: $color-grey-dark-2;
  font-size: $font-size-small;
  line-height: 1.5;
  padding: 4px 0;

  &--default:first-child {
    padding-top: 17px;
  }

  &--bold {
    font-weight: bold;
    color: $color-grey-dark-3;
    font-size: $font-size-normal;
    line-height: 1.5;
    margin-top: 13px;
    padding: 14px 0 17px;
    border-top: 1px solid $color-grey-mid-2;
  }

  &__text {
    flex: 1;
    margin-right: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
